import { type ComponentPropsWithoutRef, forwardRef } from 'react';

export const ModalContainerForm = forwardRef<
  HTMLFormElement,
  ComponentPropsWithoutRef<'form'>
>((props, ref) => <form {...props} ref={ref} noValidate />);

ModalContainerForm.displayName = 'ModalContainerForm';
